import {sanityClient} from "./sanityClient";

const PRODUCT_BRANDS_QUERY = `
  *[_type == "brand" && active == true]
  | order(sortOrder asc, title asc) {
    "slug": slug.current,
    title,
    menuSummary,
    description,
    "logo": logo.asset->url,
    "products": *[
      _type == "product" &&
      active == true &&
      references(^._id)
    ]
    | order(sortOrder asc, title asc) {
      "slug": slug.current,
      title,
      subtitle,
      "description": coalesce(description, shortDescription),
      shortDescription,
      "image": coalesce(image.asset->url, externalImageUrl),
      featured,
      "category": category->{
        "slug": slug.current,
        title
      }
    }
  }
`;

export async function getProductBrands() {
  return sanityClient.fetch(PRODUCT_BRANDS_QUERY);
}
